import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import businessDays from 'dayjs-business-days2'
import Holidays from 'date-holidays'
import { defineNuxtPlugin } from '#app'

function getLuxembourgHolidays(): string[] {
  const hd = new Holidays('LU')
  const currentYear = new Date().getFullYear()
  const holidays: string[] = []

  for (const year of [currentYear, currentYear + 1]) {
    hd.getHolidays(year)
      .filter(h => h.type === 'public')
      .forEach((h) => {
        holidays.push(dayjs(h.date).format('YYYY-MM-DD'))
      })
  }

  return holidays
}

export default defineNuxtPlugin(() => {
  dayjs.extend(relativeTime)
  dayjs.extend(businessDays, {
    holidays: getLuxembourgHolidays(),
    holidayFormat: 'YYYY-MM-DD',
  })
  dayjs.extend(customParseFormat)
  dayjs.extend(utc)
})
